import { render, staticRenderFns } from "./SameProducts.vue?vue&type=template&id=78234cb9&scoped=true&"
import script from "./SameProducts.vue?vue&type=script&lang=js&"
export * from "./SameProducts.vue?vue&type=script&lang=js&"
import style0 from "./SameProducts.vue?vue&type=style&index=0&id=78234cb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78234cb9",
  null
  
)

export default component.exports